import React, { Component } from "react"
import favorite from "../../assets/img/favorite.svg"
import favoriteO from "../../assets/img/favorite-o.svg"
import Share from "../../assets/img/ic-share.svg"

import Util from "../../utils/utils";
import CourseDetailTable from "../../components/layout/courses/table";
import AddToPlayListModal from "../../components/layout/modal/addToPlayList";
import InfoModal from "../../components/layout/modal/info";
import { Redirect } from "react-router-dom";
import axios from "axios";
import * as config from "../../config";
import Nav from "../../components/layout/nav/nav";
import ErrorModal from "../../components/layout/modal/error";
import ToastMessage from "../../components/layout/toast/toast";
import { dataService } from "../../services/dataService";


class CourseDetail extends Component
{
	constructor ( props )
	{
		super( props );

		this.state = {
			error : null,
			isLoaded : false,
			status : 200,
			isFavorite : false,
			toastShow : false,
			toastMessage : ""
		};


		this.params = this.props.match.params;
	}

	getData ( token )
	{
		try
		{
			const params = this.props.match.params;

			axios.post( config.api_url + "/courseMeta/" + params.id, {}, {
				timeout : 30000,
				headers : {
					'Content-Type' : 'application/json',
					'Authorization' : token,
				}
			} ).then( res =>
			{
				let resData = res.data;

				this.setState( ( oldState ) => ( {
					...oldState,
					isLoaded : true,
					status : 200,
					items : resData,
					isFavorite : resData.data.is_favorite,
					error : null,
				} ) );

				if ( Util.getSession( "last_item" ) === true && resData.data.last_item !== undefined && resData.data.last_item.title !== undefined && resData.data.last_item.title !== "" && resData.data.is_active )
				{
					Util.setSession( "last_item", false );

					let url = config.server_file_url + Util.encodeJwt( {
						"item_id" : resData.data.last_item.id,
						"exp" : parseInt( Date.now() / 1000 ) + ( 12 * 60 * 60 )
					} );

					if ( resData.data.last_item.data_type === "0" )
					{
						dataService.setData( {
							"name" : resData.data.last_item.title,
							"item_type" : 0,
							"currentTime" : parseInt( resData.data.last_item.time ),
							"item_id" : resData.data.last_item.id,
							"url" : url
						} );
					}
					else
					{
						dataService.setData( {
							"name" : resData.data.last_item.title,
							"currentTime" : 0,
							"item_id" : resData.data.last_item.id,
							"item_type" : 1,
							"url" : url,
							"videoJsOptions" : {
								autoplay : true,
								controls : false,
								responsive : false,
								playbackRates : [ 1, 1.25, 1.5, 1.75, 2 ],
								fluid : false,
								fill : false,
								sources : [ {
									src : url,
									type : 'video/mp4'
								} ]
							}
						} );
					}

				}

			} ).catch( error =>
			{
				this.setState( ( oldState ) => ( {
					...oldState,
					isLoaded : true,
					status : 401,
					error
				} ) );
			} );

		}
		catch ( error )
		{
			this.setState( ( oldState ) => ( {
				...oldState,
				isLoaded : true,
				status : 401,
				error
			} ) );
		}

	}

	submitFavorite = async () =>
	{
		const token = "Bearer " + Util.getSession( "token" );

		let bodyFormData = new FormData();

		bodyFormData.append( 'course_meta_id', this.params.id );
		bodyFormData.append( 'favorite_type', 1 );

		let response = await axios.post( config.api_url + "/favorites/operation", bodyFormData, {
			timeout : 30000,
			headers : {
				'Content-Type' : 'application/x-www-form-urlencoded',
				'Authorization' : token,
			}
		} );

		if ( response.data.status )
		{
			this.setState( ( oldstate ) => ( {
				...oldstate,
				isFavorite : response.data.is_favorite
			} ) );
		}
	};

	CheckToken ( token )
	{
		try
		{
			axios.post( config.api_url + "/account/refresh-token", {}, {
				timeout : 30000,
				headers : {
					'Content-Type' : 'application/json',
					'Authorization' : token,
				}
			} ).then( res =>
			{
				if ( res.data.status )
				{
					Util.setSession( "token", res.data.token );
				}

				const token = "Bearer " + Util.getSession( "token" );
				this.getData( token );

			} ).catch( error =>
			{

			} );

		}
		catch ( error )
		{

		}
	}


	componentDidMount ()
	{
		this.CheckToken( "Bearer " + Util.getSession( "token" ) );
	}

	componentDidUpdate ( prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS ): void
	{
		Util.convertNumberToPersion( document.body );
	}

	handleRefresh = () =>
	{
		this.setState( ( oldstate ) => ( { ...oldstate, errorShow : false } ) );
		window.location.reload();
	};

	hideToast = () =>
	{
		this.setState( ( oldState ) => ( { ...oldState, toastShow : false } ) );
	};

	copyToClipBoard = () =>
	{
		navigator.clipboard.writeText( window.location.href ).then( r =>
		{
			this.setState( ( oldState ) => ( {
				...oldState,
				toastShow : true,
				toastMessage : "با موفقیت در کلیپ بورد ذخیره شد!"
			} ) );
		} );
	};

	render ()
	{
		const token = Util.getSession( "token" );

		if ( !token )
			return <Redirect to="/login"/>;

		const { error, isLoaded, items } = this.state;

		if ( error )
		{
			return (
				<ErrorModal show={true} handleRefresh={this.handleRefresh} title="خطا!" buttonStatus={true} message="در دریافت اطلاعات مشکلی به وجود آمده است!" style={{
					"color" : "red",
					"fontSize" : "50px"
				}} iconName="fa-close"/>
			);
		}
		else if ( !isLoaded )
		{
			return (
				<ErrorModal show={true} handleRefresh={this.handleRefresh} title="لطفا منتظر بمانید" buttonStatus={false} message="در حال دریافت اطلاعات ..." style={{
					"color" : "white",
					"fontSize" : "50px"
				}} iconName="fa-refresh fa-spin"/>
			);
		}
		else
		{
			let course = items.data.course;
			let course_meta = items.data.course_meta;
			let course_meta_items = course_meta.data;
			let playList = items.data.playList;

			this.navUrls = [
				{
					id : 1,
					class : "active",
					name : "دارالشفاء",
					link : "/"
				} ];

			if ( !course.route_path )
			{
				this.navUrls.push( {
					id : 2,
					class : "",
					name : course.title,
					link : "/course/" + course.id
				} );
			}


			this.navUrls.push( {
				id : 3,
				class : "active",
				name : course_meta.title,
				link : "/course/detail/" + course_meta.id
			} );

			return (
				<>
					<main>
						<Nav urls={this.navUrls}/>
						<section className="courses-header" style={{
							"backgroundImage" : 'url(' + course.image + ')'
						}}>
							<div className="courses-header-shadow"/>
							<h1 className="course-title course-track">
								{course.title}
							</h1>							{
							!course.route_path &&
							<h4 className="course-track-title">
								{course_meta.title}
							</h4>
						}
						</section>
						<section className="course-section row">
							<div className="col-sm-4 col-12 course-section-div row m-0 p-0">
								{
									course_meta.description &&
									<div className="col-12 course-description-div order-sm-1 order-2">
										<p className="course-description">
											{course_meta.description}
										</p>
									</div>
								}
								<div className="col-12 course-session-detail order-sm-1 order-2">
									<div className="d-flex">
										<div className="course-session-count">
											<p>
												{course_meta.items_count} جلسه
											</p>
										</div>
										<div className="course-session-time">
											<p>
												{Math.ceil( course_meta.items_time / 3600 )} ساعت
											</p>
										</div>
									</div>
								</div>
								<div className="col-12 course-tool-div row order-sm-2 order-1">
									<div className="col-6 p-0 align-self-center">
										<a className="course-tool row" href="#0" onClick={this.submitFavorite}>
											{
												this.state.isFavorite &&
												<img className="course-tool-img" src={favorite} alt=""/>
											} {
											!this.state.isFavorite &&
											<img className="course-tool-img" src={favoriteO} alt=""/>
										} مورد علاقه </a>
									</div>
									<div className="col-6 p-0 align-self-center">
										<a className="course-tool row" href="#0" onClick={this.copyToClipBoard}>
											<img className="course-tool-img" src={Share} alt=""/> اشتراک گذاری </a>
									</div>
								</div>
							</div>
							<div className="col-sm-8 col-12 course-subjects">
								<div className="course-subject-div">
									<CourseDetailTable itemList={course_meta_items} playList={playList} type="course"/>
								</div>
							</div>
						</section>
						<ToastMessage show={this.state.toastShow} handleClose={this.hideToast} message={this.state.toastMessage}/>
						<AddToPlayListModal/> <InfoModal/>
					</main>
				</>
			)
		}
	}
}

export default CourseDetail;